export default __webpack_public_path__ + "static/TeamFour-cee5a61a7cb9610809d2b16a144ad8bb.webp";